import { Box, styled } from '../../../../../base';

export const ButtonsContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '10px',
});
